import React from 'react';
import {Field, useForm} from 'react-final-form';
import block from 'bem-cn-lite';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {FormFieldNumberInput} from 'components/formFields';
import CalculatorForm from 'components/calculator/CalculatorForm/CalculatorForm';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import {CalculatorProps} from 'components/calculator/models';

import './TranslateForm.scss';

const b = block('TranslateForm');

export interface TranslateFormValues {
    count: number;
}

type TranslateFormProps = CalculatorProps & WithTranslationProps;

const TranslateForm: React.FC<TranslateFormProps> = (props) => {
    const {title, i18nK} = props;
    const {initialize} = useForm<TranslateFormValues>();

    React.useEffect(() => {
        initialize({count: 100000});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <CalculatorForm title={title} className={b()}>
            <CalculatorFormLayout>
                <CalculatorFormLayout.Section>
                    <CalculatorFormLayout.Row
                        title={i18nK('field_translate-count')}
                        note={i18nK('context_translate-count')}
                    >
                        <Field name="count">
                            {(fieldProps) => (
                                <FormFieldNumberInput
                                    {...fieldProps}
                                    size="l"
                                    step={100000}
                                    className={b('count')}
                                    defaultValue={1}
                                    range={{min: 1}}
                                />
                            )}
                        </Field>
                    </CalculatorFormLayout.Row>
                </CalculatorFormLayout.Section>
            </CalculatorFormLayout>
        </CalculatorForm>
    );
};

export default withTranslation('calculator')(TranslateForm);
